import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiInterface } from '../api-interface';
import { ApiService } from '../api.service';
import {
  ConfiguracaoGeralDTO,
  ConfiguracaoGeralResponseDTO,
} from '../../models/configuracoes/configuracao-geral.model';

/**
 * Service dedicado ao CRUD da Configuracao Geral.
 *
 * Endpoints (base /api): /configuracaoGeral
 * - GET    /configuracaoGeral        -> lista paginada (Page<ConfiguracaoGeralDTO>)
 * - GET    /configuracaoGeral/{id}   -> registro completo
 * - POST   /configuracaoGeral        -> cria (exige usuario master, 403 caso contrario)
 * - PUT    /configuracaoGeral/{id}   -> atualiza (exige master)
 * - DELETE /configuracaoGeral/{id}   -> remove (exige master)
 *
 * Fonte da verdade:
 * vendas/docs/api/API_CONTRACT_configuracao-geral-tipo-despesa-especial.md
 */
@Injectable({
  providedIn: 'root',
})
export class ConfiguracaoGeralService implements ApiInterface {
  constructor(private apiService: ApiService) {}

  get<T>(url: string, data?: any): Observable<ConfiguracaoGeralResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const path = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<ConfiguracaoGeralResponseDTO>(path);
  }

  getById<T>(url: string): Observable<ConfiguracaoGeralDTO> {
    return this.apiService.read<ConfiguracaoGeralDTO>(url);
  }

  post<T>(url: string, data: ConfiguracaoGeralDTO): Observable<ConfiguracaoGeralDTO> {
    return this.apiService.create<ConfiguracaoGeralDTO>(url, data);
  }

  put<T>(url: string, data: ConfiguracaoGeralDTO): Observable<ConfiguracaoGeralDTO> {
    return this.apiService.update<ConfiguracaoGeralDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }
}
